<div class="sg-signature-pad-container__wrapper">
  <div class="sg-signature-pad-container__close">
    <mat-icon [ngClass]="{'disabled': isOperationFinished, 'allow': !isOperationFinished}" class="icon close"
      (click)="closePad()">close</mat-icon>
  </div>
  <div class="container" id="container">
    <div class="containerQR" id="containerQR" *ngIf="!mobile && routeQR !== ''">
      <p class="title">{{ 'firma_desde_movil' | translate:_transParam }}</p>
      <mat-divider></mat-divider>
      <p class="subtitle">{{ 'escanea_qr' | translate:_transParam }}</p>
      <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="routeQR"
        cssClass="bshadow"></ngx-qrcode>
      <P class="description">{{ 'escanea_qr_descripcion' | translate:_transParam }}</P>
    </div>
    <div>
      <div id="container-pad" class="container-pad">
        <app-ivpad [ngClass]="{ isDisabled: verifyPressure && !deviceAllowed }" #ivpad [startOpened]="true"
          [opened]="true" [isModal]="true" (onRequestReady)="signPDF($event)" [showButtons]="true"
          [signingEnabled]="true" cdkFocusInitial>
        </app-ivpad>
      </div>
      <div class="buttons">
        <signaturit-button text="{{ 'labels_search_cancel' | translate:_transParam }}" type="tertiary" size="md"
          (click)="clearSign()" [disabled]="isOperationFinished"></signaturit-button>
        <signaturit-button class="btn" text="{{ 'finish_btn_sign' | translate:_transParam }}"
          type="primary" size="md" (click)="sign()"
          [disabled]="isOperationFinished || (verifyPressure && !deviceAllowed)"
          [showLoader]="isOperationFinished"></signaturit-button>
      </div>
      <div *ngIf="biometry">
        <div *ngIf="!verifyPressure && !deviceAllowed && !mobile" class="info advise" id="messageContainer">
          <mat-icon class="icon help">help</mat-icon>
          <p class="mb-0">{{'finish_sigbio_custom_01' | translate:_transParam}}</p>
        </div>
        <div *ngIf="verifyPressure && !deviceAllowed && !mobile" class="info advise" id="messageContainer">
          <mat-icon class="icon cancel">cancel</mat-icon>
          <p class="mb-0">{{'finish_sigbio_custom_02' | translate:_transParam}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
